module.exports = __webpack_public_path__ + "static/media/em-04.18ca984d.png";